<template>
    <div>
        <div v-if="authUserPermission['sub-menu-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col-7">
                                <h3 class="mb-0">{{ tt('sub_menu') }}</h3>
                            </div>
                            <div class="col-5">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_sub_menu')" v-on:keyup="filter"/>                            
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('menu')" :prop="tt('menu')" sortable>
                                <template v-slot="{row}">
                                    {{row.a_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('sub_menu')" :prop="tt('sub_menu')" sortable>
                                <template v-slot="{row}">
                                    {{row.am_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('status')" :prop="tt('status')" min-width="100px" sortable>
                                <template v-slot="{row}">
                                    {{row.am_status}}
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['sub-menu-update'] || authUserPermission['sub-menu-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['sub-menu-update']">Edit</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['sub-menu-delete']">Delete</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column> -->
                        </el-table>
                        <page-loading v-else/>
                    </div>  
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('menu') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('menu')" rules="required">
                            <el-select class="select-danger" v-model="manageSubMenu.menu_id" :placeholder="tt('choose_menu')">
                                <el-option class="select-danger" :value="mm['id']" :label="mm['name']" :key="mm['menu']" v-for="mm in  manageMenu"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('sub_menu') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('name')" :placeholder="tt('sub_menu')" v-model="manageSubMenu.name" rules="required|max:50"></base-input>

                        <label class="form-control-label">{{ tt('status') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('status')" rules="required">
                            <el-select class="select-danger" v-model="manageSubMenu.status" placeholder="Choose Status">
                                <el-option class="select-danger" value="Active" label="Active" key="Active"></el-option>
                                <el-option class="select-danger" value="Non Active" label="Non Active" key="Non Active"></el-option>
                                <el-option class="select-danger" value="Maintenance" label="Maintenance" key="Maintenance"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import manageSubMenu from '@/services/setting/manageSubMenu.service';
    import manageMenu from '@/services/setting/manageMenu.service';

    export default {        
        data() {
            return {      
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },                    
                form: {
                    add: true,
                    title: "Create New Sub Menu",
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,   
                manageMenu: {},
                manageSubMenu: {},
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getManageMenu()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, manageSubMenu.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data; 
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getManageMenu() {
                let context = this;               
                Api(context, manageMenu.get({})).onSuccess(function(response) {    
                    context.manageMenu = response.data.data.data.data;
                    // console.log(response.data.data.data.data)
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.manageMenu = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_new_sub_menu');
                this.form.show = true;
                this.manageSubMenu = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, manageSubMenu.show(id)).onSuccess(function(response) {
                    context.manageSubMenu = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('update_sub_menu');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, manageSubMenu.create(this.manageSubMenu));
                } else {{
                    api = Api(context, manageSubMenu.update(this.manageSubMenu.id, this.manageSubMenu));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, manageSubMenu.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
